<template>
  <v-data-table
    :loading="loading"
    :headers="headers"
    :items="getFilteredWastes"
    :items-per-page="getFilteredWastes.length + 1"
    hide-default-footer
    :group-by="groupBy ? 'fk_product' : []"
    :group-desc="true"
    sort-by="created"
    :sort-desc="true"
    :mobile-breakpoint="0"
    dense
  >
    <template v-slot:group.header="{ group }">
      <td></td>
      <td>
        {{ getGroupTotal(group) }}
        <span class="caption ml-1">{{ getUnitById(group) }}</span>
      </td>
      <td></td>
    </template>
    <template v-slot:item.created="{ item }">
      <span class="caption">{{ item.created | denseDateHourFormat }}</span>
    </template>
    <template v-slot:item.quantity="{ item }">
      <span class="caption">{{ Number(item.quantity) | round2 }}</span>
      <span class="overline ml-1">{{ getUnit(item) }}</span>
    </template>
    <template v-slot:item.waste_cause="{ item }">
      <span class="caption">{{ getWasteCauseName(item) }}</span>
    </template>
  </v-data-table>
</template>

<script>
import { mapGetters } from "vuex";
import { api } from "@/api";
import { round10 } from "round10";
import moment from "moment";
export default {
  name: "WastesGrid",
  props: {
    take: {
      required: true
    },
    productFilter: {
      required: true
    },
    start: {
      required: true
    },
    end: {
      required: true
    },
    groupBy: {
      required: true
    }
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapGetters(["getProducts", "getWasteCauses"]),
    getFilteredWastes() {
      return this.productFilter
        ? this.data.filter(x => x.fk_product === this.productFilter)
        : this.data;
    }
  },
  data() {
    return {
      data: [],
      loading: false,
      headers: [
        { value: "created", text: "Date", sortable: false, class: "px-1" },
        {
          value: "quantity",
          text: "Valeur (qté)",
          sortable: false,
          class: "px-1"
        },
        { value: "waste_cause", text: "Cause", sortable: false, class: "px-1" }
      ]
    };
  },
  methods: {
    async getData() {
      if (this.take !== null || this.start !== null) {
        try {
          this.loading = true;
          this.data = await api.getInventoryTransactions({
            take: this.take,
            product: this.productFilter,
            waste: true,
            start:
              this.start != null
                ? moment(this.start)
                    .hours(0)
                    .minutes(0)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.start,
            end:
              this.end != null
                ? moment(this.end)
                    .hours(23)
                    .minutes(59)
                    .format("YYYY-MM-DDTHH:mm:ss.SSSSSSZ")
                : this.end
          });
        } finally {
          this.loading = false;
        }
      }
    },
    getProductName(item) {
      return this.getProducts.find(x => x.id === item.fk_product)
        ? this.getProducts.find(x => x.id === item.fk_product).nom
        : "";
    },
    getProductNameById(id) {
      return this.getProducts.find(x => x.id == id)
        ? this.getProducts.find(x => x.id == id).nom
        : "";
    },
    getWasteCauseName(item) {
      return this.getWasteCauses.find(x => x.id === item.waste_cause)
        ? this.getWasteCauses.find(x => x.id === item.waste_cause).name
        : "";
    },
    getUnit(item) {
      return this.getProducts.find(x => x.id === item.fk_product)
        ? this.getProducts.find(x => x.id === item.fk_product).data
          ? this.getProducts.find(x => x.id === item.fk_product).data
              .unite_mesure_inventory
          : ""
        : "";
    },
    getUnitById(id) {
      return this.getProducts.find(x => x.id == id)
        ? this.getProducts.find(x => x.id == id).data
          ? this.getProducts.find(x => x.id == id).data.unite_mesure_inventory
          : ""
        : "";
    },
    getGroupTotal(id) {
      return round10(
        this.data
          .filter(x => x.fk_product == id)
          .map(x => Number(x.quantity))
          .reduce((a, b) => a + b, 0),
        -4
      );
    }
  },
  watch: {
    take(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    productFilter(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    start(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    },
    end(v, oldv) {
      if (v !== oldv) {
        this.getData();
      }
    }
  }
};
</script>

<style></style>
